import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"
import _imports_0 from '../../assets/team-effectiveness/celebrate.png'


const _hoisted_1 = {
  key: 0,
  class: "team-effectiveness-questionnaire-page container maxWidth-sm text-big"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  class: "row",
  style: {"margin":"20px 0"}
}
const _hoisted_4 = { class: "col-sm-12 text-center" }
const _hoisted_5 = { style: {"margin":"20px","word-break":"break-word"} }
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = { class: "col-sm-12 text-center" }
const _hoisted_8 = { class: "text-danger" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-sm-4 col-sm-offset-4 text-center",
    style: {"padding":"30px"}
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "img-responsive",
      src: _imports_0,
      alt: "Congratulations!"
    })
  ])
], -1)
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-sm-12 text-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { style: {"margin":"20px 0"} }, "Click the button below to access your report.", -1)
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-sm-12 text-center" }
const _hoisted_16 = ["href"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-sm-12 text-center",
    style: {"margin":"20px 0"}
  }, [
    /*#__PURE__*/_createElementVNode("p", null, " If you’d like to complete a Team Effectiveness Questionnaire on a different team, close this session and select another team or create a new one from the top of the page. ")
  ])
], -1)

import { debug as d } from "debug";
import axios from "axios";
import { computed, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import {
  TeamApiModel,
  TeamEffectivenessQuestionnaireApiModel,
  TeamEffectivenessQuestionnaireCreationApiModel,
  TeamEffectivenessRatingsApiModel,
  TeamEffectivenessReviewApiModel,
} from "../../api-models";
import { CsCustomRouter } from "../../router/router";
import TeamEffectivenessQuestionnaire from "../../components/team-effectiveness/team-effectiveness-questionnaire.vue";
import {
  getTeamEffectivenessReportTeamId,
  getTeamEffectivenessReportReviewId,
} from "../../components/team-effectiveness/get-team-effectiveness-report-team-id";


export default /*#__PURE__*/_defineComponent({
  __name: 'team-effectiveness-questionnaire-page',
  setup(__props) {

const debug = d("cs.TeamEffectivenessQuestionnairePage");

const route = useRoute();
const router = useRouter();

const teamId = computed(() => getTeamEffectivenessReportTeamId(route));
const reviewId = computed(() => getTeamEffectivenessReportReviewId(route));

const model = ref<TeamApiModel | null>(null);
const error = ref<string | null>(null);
const isSubmitting = ref(false);
const hasAlreadyCompletedQuestionnaire = ref<boolean | null>(null);
const openReviewIdForTeam = ref<string | null>(null);

function onSubmit(rawRatings: TeamEffectivenessRatingsApiModel): void {
  isSubmitting.value = true;
  error.value = null;
  const request = {
    reviewId: reviewId.value,
    rawRatings,
  } as TeamEffectivenessQuestionnaireCreationApiModel;
  axios
    .post("/api/teameffectivenessquestionnaire", request)
    .then(() => {
      if ((router as CsCustomRouter).isCurrentRouteInSlidingStack) {
        (router as CsCustomRouter).closeSlidingStack();
      } else {
        // Navigate to team dashboard...
        window.location.href = `/team/dashboard/${teamId.value}`;
      }
    })
    .catch((err) => {
      debug(err);
      isSubmitting.value = false;
      error.value = "There was a problem submitting. Please try again.";
    });
}

const reportUrl = computed(() => `/teameffectivenessreport/view/${reviewId.value}`);

onMounted(async () => {
  if (!reviewId.value) {
    // Find the open review for the team
    const openReviewForTeam = await axios
      .get(`/api/teameffectivenessreview/getallforteam?teamId=${teamId.value}`)
      .then((resp) => {
        const data = resp.data as TeamEffectivenessReviewApiModel[];
        if (data && data.length > 0 && !data[0].completedDate) {
          return data[0];
        }
        return null;
      });
    if (openReviewForTeam) {
      openReviewIdForTeam.value = openReviewForTeam.id;
    } else {
      // No open review for the team... redirect to the highlights page
      router.replace(`/team/effectiveness/${teamId.value}`);
    }
  }

  await axios
    .get(`/api/teameffectivenessquestionnaire/?reviewId=${reviewId.value}`)
    .then((resp) => {
      const data = resp.data as TeamEffectivenessQuestionnaireApiModel | null;
      hasAlreadyCompletedQuestionnaire.value = !!data;
    });

  // Retrieve the team details (including the name...)
  await axios.get(`/api/teams/${teamId.value}`).then((resp) => {
    const data = resp.data as TeamApiModel;
    model.value = data;
  });
});

return (_ctx: any,_cache: any) => {
  return (model.value && hasAlreadyCompletedQuestionnaire.value != null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!hasAlreadyCompletedQuestionnaire.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h1", _hoisted_5, " Team Effectiveness Questionnaire for '" + _toDisplayString(model.value.name) + "' ", 1)
                ])
              ]),
              (error.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("p", _hoisted_8, _toDisplayString(error.value), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(TeamEffectivenessQuestionnaire, {
                onSubmit: onSubmit,
                "is-submitting": isSubmitting.value
              }, null, 8, ["is-submitting"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("h3", null, " You have already completed your Team Effectiveness Questionnaire for '" + _toDisplayString(model.value.name) + "'. ", 1),
                  _hoisted_13
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("a", {
                    class: "btn btn-primary btn-lg",
                    href: reportUrl.value
                  }, "Open Team Effectiveness Report", 8, _hoisted_16)
                ])
              ]),
              _hoisted_17
            ]))
      ]))
    : _createCommentVNode("", true)
}
}

})